import React from "react";

export default function Item({ icon, number, subtitle, onClick }) {
  return (
    <div
      className="item-card d-flex flex-column align-items-start justify-content-between p-3 border border-1 shadow-sm rounded-3 text-dark w-100 h-100"
      onClick={onClick}
      style={{
        backgroundImage: "url('/images/background.svg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        cursor: onClick ? "pointer" : "default",
        transition: "transform 0.2s, box-shadow 0.2s"
      }}
      onMouseEnter={(e) => {
        if (onClick) {
          e.currentTarget.style.transform = "translateY(-2px)";
          e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.15)";
        }
      }}
      onMouseLeave={(e) => {
        if (onClick) {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "";
        }
      }}
    >
      <img src={icon} alt="icon" className="mb-3" width={28} height={28} />
      <div className="fs-5 fw-bold text-truncate w-100">{number}</div>
      <div className="text-muted text-truncate w-100" style={{ fontSize: "14px" }}>{subtitle}</div>
    </div>
  );
}
